module.exports = __webpack_public_path__ + "img/组件2.8e79fa19.png";